import React from 'react'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import PropTypes from 'prop-types'
import './select.scss'
import styles from '../CustomInputs/inputs.module.scss'

const Selector = ({
  name,
  label,
  value,
  options,
  placeholder,
  onChange,
  disabled,
  error,
  isMulti,
  isCreatable,
  className,
  style,
  selectClassName,
  selectStyle,
}) => {
  const props = {
    placeholder,
    value,
    options,
    onChange: (selected) => onChange({ target: { name, value: selected } }),
    isMulti,
    className: selectClassName,
    styles: selectStyle,
    isDisabled: disabled,
  }
  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      font: 'normal normal 600 16px/22px Source Sans Pro',
      color: '#9393aa',
      width: '100%',
    }),
    // You can add more custom styles for other parts of the select here
  }
  return (
    <div className={`select-root ${className}`} style={style}>
      {label && <label className={styles.label}>{label}</label>}
      <span className={error && 'select-control-error'}>
        {isCreatable ? (
          <Creatable {...props} classNamePrefix="select" />
        ) : (
          <Select {...props} classNamePrefix="select" styles={customStyles} />
        )}
      </span>
      {error && <span className="select-error">{error}</span>}
    </div>
  )
}

Selector.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.shape([]),
  options: PropTypes.shape([]),
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  mandatory: PropTypes.bool,
  isMulti: PropTypes.bool,
  isCreatable: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  selectClassName: PropTypes.string,
  selectStyle: PropTypes.shape({}),
}

Selector.defaultProps = {
  name: 'select',
  label: null,
  value: [],
  options: [],
  placeholder: null,
  error: null,
  onChange: () => {},
  disabled: false,
  mandatory: false,
  isMulti: false,
  isCreatable: false,
  className: '',
  style: {},
  selectClassName: '',
  selectStyle: {},
}

export default Selector
